<template>
	<DBForm :store="store" :config="settings" :data="data" :readonlyForm="readonly" :watchChange="true" ref="form">
		<template v-slot="form">
			<div class="card-body">
				<div class="form-row">
					<div class="col-lg-12">
						<DBEdit :form="form" field="signalType" />
					</div>
				</div>
				<div class="form-row" v-if="store.data.signalType === 'custom'">
					<div class="col-lg-12">
						<DBEdit :form="form" field="customDate" />
					</div>
				</div>
				<div class="form-row">
					<div class="col-lg-12">
						<DBEdit :form="form" field="description" rows="5" />
					</div>
				</div>
			</div>
		</template>
	</DBForm>
</template>

<script lang="ts">
import { defineComponent, ref, watch, nextTick } from "vue";
import EditController from "@/core/EditController";
import DBStoreRecord from "@/core/db_store_record";
import { deepClone } from "@/helpers/utils";
import dayjs from "dayjs";

export default defineComponent({
	props: {
		data: {
			type: Object,
			default: () => ({}),
		},
		fieldValue: {
			type: [String, Date],
			required: true
		},
		fieldDescription: {
			type: String,
			default: ''
		},
		signal: {
			type: Object,
			default: null
		}
	},
	setup(props) {
		const form = ref(null);
		
		// Создаем config с полями
		const config = {
			fields: {
				signalType: {
					description: "Тип уведомления",
					type: {
						enum: [
							{
								id: "week",
								name: "Уведомить за неделю"
							},
							{
								id: "month",
								name: "Уведомить за месяц"
							},
							{
								id: "custom",
								name: "Выбрать дату"
							}
						]
					}
				},
				customDate: {
					description: "Дата уведомления",
					type: "DATEONLY"
				},
				description: {
					description: "Описание",
					type: "TEXT"
				}
			}
		};
		
		// Создаем store
		const store = new DBStoreRecord("signalDialog", deepClone(config));
		
		const controllerProps = {
			store: store,
			config: config,
			data: props.data || {},
			params: {},
			panel: undefined
		};
		
		const controller = new EditController(form, controllerProps);
		const setupResult = controller.setup();
		
		// Инициализация данных после создания контроллера
		nextTick(() => {
			if (props.signal) {
				const signalDate = dayjs(props.signal.notify_date);
				const fieldDate = dayjs(props.fieldValue);
				const diffDays = fieldDate.diff(signalDate, 'day');
				
				let signalType = 'week';
				let customDate = '';
				
				if (diffDays === 7) {
					signalType = 'week';
				} else if (diffDays === 30 || diffDays === 31) {
					signalType = 'month';
				} else {
					signalType = 'custom';
					customDate = signalDate.format('YYYY-MM-DD');
				}

				// Устанавливаем значения через setValue для правильной реактивности
				store.setValue('signalType', signalType);
				store.setValue('customDate', customDate);
				store.setValue('description', props.signal.description || '');
			} else {
				store.setValue('signalType', 'week');
				store.setValue('customDate', '');
				store.setValue('description', '');
			}
		});

		// Отслеживаем изменение signalType и очищаем customDate если нужно
		watch(
			() => store.data.signalType,
			(newValue) => {
				if (newValue !== 'custom') {
					store.data.customDate = '';
				}
			}
		);

		return {
			store: store,
			settings: config,
			readonly: setupResult.readonly,
			controller: controller,
			form: form,
			data: props.data
		};
	},
});
</script>

